// Development only: shows the warnings Bullet raises for an API call (an N+1 query, see config/initializers/bullet.rb).
//
// Bullet puts the warnings of a JSON response in its X-bullet-footer-text header. Its own page script reads them, but only for classic XHR
// calls; this app talks to /api/v1 with redaxios, which uses fetch, so without this nothing would ever reach the screen. A small red
// badge appears at the bottom left (only when there is something to report), a click opens the list, and each warning is also written to
// the browser console. Not in the production bundle: `import.meta.env.DEV` is false there and the whole file is dropped.
const warnings = new Map()
let box = null

function render() {
  if (!box) {
    box = document.createElement('div')
    box.id = 'bullet-api-warnings'
    box.style.cssText = 'position:fixed;left:0;bottom:0;z-index:99999;font:12px/1.4 ui-monospace,Menlo,monospace;max-width:min(560px,100vw)'
    document.body.appendChild(box)
  }
  const total = [...warnings.values()].reduce((sum, item) => sum + item.count, 0)
  box.replaceChildren()

  const badge = document.createElement('button')
  badge.type = 'button'
  badge.textContent = `Bullet: ${warnings.size} query warning${warnings.size === 1 ? '' : 's'} (${total})`
  badge.style.cssText = 'display:block;background:#fdf2f2;color:#9b1c1c;border:1px solid #9b1c1c;border-radius:0 8px 0 0;padding:4px 10px;cursor:pointer;font:inherit'
  badge.addEventListener('click', () => { box.dataset.open = box.dataset.open === 'true' ? 'false' : 'true'; render() })
  box.appendChild(badge)

  if (box.dataset.open !== 'true') return
  const list = document.createElement('div')
  list.style.cssText = 'background:#fff;color:#111;border:1px solid #9b1c1c;border-bottom:0;max-height:55vh;overflow:auto;padding:8px 10px'
  warnings.forEach((item) => {
    const entry = document.createElement('pre')
    entry.style.cssText = 'margin:0 0 10px;white-space:pre-wrap;word-break:break-word'
    entry.textContent = `${item.request}${item.count > 1 ? `  (x${item.count})` : ''}\n${item.text}`
    list.appendChild(entry)
  })
  const clear = document.createElement('button')
  clear.type = 'button'
  clear.textContent = 'Clear'
  clear.style.cssText = 'border:1px solid #9b1c1c;color:#9b1c1c;background:#fff;border-radius:6px;padding:2px 10px;cursor:pointer;font:inherit'
  clear.addEventListener('click', () => { warnings.clear(); box.remove(); box = null })
  list.appendChild(clear)
  box.insertBefore(list, badge)
}

// `response` is what redaxios answered; `request` says which call it was ({ type, url }).
export function reportBulletWarnings(response, request) {
  if (!import.meta.env.DEV) return
  const raw = response?.headers?.get?.('x-bullet-footer-text')
  if (!raw) return
  let items = []
  try { items = JSON.parse(raw) } catch { return }
  const label = `${request.type} ${String(request.url).split('?')[0]}`
  items.forEach((text) => {
    const key = `${label}|${text}`
    const known = warnings.get(key)
    if (known) { known.count += 1; return }
    warnings.set(key, { request: label, text, count: 1 })
    console.warn(`[Bullet] ${label}\n${text}`)
  })
  render()
}
